import React from 'react';

export default function SohlLogo () {
  return (
    <svg width="32" height="43" viewBox="0 0 32 43" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.800003 37.84C1.42 38.34 2.47 39.07 3.98 39.8C6.43 40.98 10.65 42.39 16.79 42.39C22.87 42.39 26.7 41.01 28.84 39.85C30.16 39.14 31.02 38.42 31.51 37.94L28.75 34.19C25.76 30.14 21.16 27.81 16.12 27.81C11.08 27.81 6.48 30.14 3.49 34.19L0.800003 37.84Z" fill="#FAFAFA"/>
      <path d="M16.12 0.0299988C9.88001 0.0299988 4.81001 5.1 4.81001 11.34C4.81001 17.58 9.88001 22.65 16.12 22.65C22.36 22.65 27.43 17.58 27.43 11.34C27.43 5.11 22.35 0.0299988 16.12 0.0299988Z" fill="#FAFAFA"/>
    </svg>
  )
}
